import React, { useState } from 'react'
import { useStateValue } from '@State'
import { filterPeople } from '../actions'
import { CourseSectionFilter } from './CourseSectionFilter'
import { toast } from '@CommonComponents/toast'

export const FilterForm = () => {
  const [currentState, dispatch] = useStateValue()

  const [lastName, setLastName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [email, setEmail] = useState('')
  const [signupDateUpperBound, setSignupDateUpperBound] = useState('')
  const [signupDateLowerBound, setSignupDateLowerBound] = useState('')
  const [courseSection, setCourseSection] = useState('All Sections')
  const [displayFilterReset, setDisplayFilterReset] = useState(false)
  const [lastLoginLowerBound, setLastLoginLowerBound] = useState('')
  const [lastLoginUpperBound, setLastLoginUpperBound] = useState('')

  const handleText = event => {
    const { name, value } = event.target
    const setters = {
      lastName: setLastName,
      firstName: setFirstName,
      email: setEmail,
      signupDateUpperBound: setSignupDateUpperBound,
      signupDateLowerBound: setSignupDateLowerBound,
      courseSection: setCourseSection,
      lastLoginLowerBound: setLastLoginLowerBound,
      lastLoginUpperBound: setLastLoginUpperBound,
    }
    if (setters[name]) setters[name](value)
  }

  const filter = async event => {
    event.preventDefault()

    let filters = {}
    filters.lastNameFilter = lastName
    filters.firstNameFilter = firstName
    filters.emailFilter = email
    filters.signupDateUpperBound = signupDateUpperBound
    filters.signupDateLowerBound = signupDateLowerBound
    filters.sectionFilter = courseSection
    filters.lastLoginLowerBound = lastLoginLowerBound
    filters.lastLoginUpperBound = lastLoginUpperBound
    filters.pageNum = currentState.currentCourseMemPage
    filters.archivedPageNum = currentState.currentArchivePage

    dispatch({ type: 'UPDATE_FILTERS', payload: filters })
    try {
      await filterPeople(filters, dispatch)
    } catch (err) {
      toast.error('There was a problem filtering people.')
    }

    setDisplayFilterReset(true)
  }

  const resetFilters = async () => {
    setLastName('')
    setFirstName('')
    setEmail('')
    setSignupDateLowerBound('')
    setSignupDateUpperBound('')
    setCourseSection('All Sections')
    setDisplayFilterReset(false)
    setLastLoginLowerBound('')
    setLastLoginUpperBound('')
    dispatch({ type: 'RESET_FILTERS' })
    try {
      await filterPeople({}, dispatch)
    } catch (err) {
      toast.error('There was a problem resetting filters.')
    }
  }

  const allFilters = () => {
    let filters = ['All Sections', 'Unassigned Members']
    currentState.allSectionData.map(sec => filters.push(sec.secName))
    return filters
  }

  return (
    <div>
      <form>
        <div className="form-group">
          <div>
            <label htmlFor="lastName">Last Name Contains:</label>
          </div>
          <input
            className="form-control"
            id="lastName"
            name="lastName"
            value={lastName}
            onChange={handleText}
            type="text"
          />
          <div>
            <label htmlFor="firstName">First Name Contains:</label>
          </div>
          <input
            className="form-control"
            id="firstName"
            name="firstName"
            value={firstName}
            onChange={handleText}
            type="text"
          />
          <div>
            <label htmlFor="email">Email Address Contains:</label>
          </div>
          <input
            className="form-control"
            id="email"
            name="email"
            value={email}
            onChange={handleText}
            type="text"
          />
        </div>
        <div className="form-group">
          <div>
            <label htmlFor="signupDates">Signup Date Between:</label>
          </div>
          <input
            className="form-control"
            id="signupDates"
            name="signupDateLowerBound"
            value={signupDateLowerBound}
            onChange={handleText}
            type="date"
          />
          <div>
            <label htmlFor="signupDatesUpperBound">and</label>
          </div>
          <input
            className="form-control"
            id="signupDatesUpperBound"
            name="signupDateUpperBound"
            value={signupDateUpperBound}
            onChange={handleText}
            type="date"
          />
        </div>
        <div>
          <div>
            <label htmlFor="loginLower">Last Login Date Between:</label>
          </div>
          <input
            className="form-control"
            id="loginLower"
            name="lastLoginLowerBound"
            value={lastLoginLowerBound}
            onChange={handleText}
            type="date"
          />
          <div>
            <label htmlFor="loginUpper">and</label>
          </div>
          <input
            className="form-control"
            id="loginUpper"
            name="lastLoginUpperBound"
            value={lastLoginUpperBound}
            onChange={handleText}
            type="date"
          />
        </div>
        <div>
          <label htmlFor="courseSections">Course Section:</label>
          <div
            id="courseSections"
            className="bg-white d-block border rounded p-3"
          >
            <ul className="d-table-row">
              <fieldset>
                {allFilters().map((secFilter, i) => (
                  <CourseSectionFilter
                    filter={secFilter}
                    checkedFilter={courseSection}
                    handleText={handleText}
                    key={i}
                  />
                ))}
              </fieldset>
            </ul>
          </div>
        </div>
        <div className="mt-4">
          <button
            className="btn btn-myed btn-default btn-default-myed"
            type="submit"
            onClick={filter}
          >
            Apply Filters
          </button>
          {displayFilterReset ? (
            <button
              className="btn btn-myed btn-default btn-default-myed ml-1"
              type="reset"
              onClick={resetFilters}
            >
              Reset
            </button>
          ) : null}
        </div>
      </form>
    </div>
  )
}
